import { render, staticRenderFns } from "./manageStudies.vue?vue&type=template&id=379d6b4d&scoped=true&"
import script from "./manageStudies.vue?vue&type=script&lang=js&"
export * from "./manageStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d6b4d",
  null
  
)

export default component.exports